"use client";

import { useEffect } from "react";

export default function PerformanceMonitor() {
  useEffect(() => {
    if (typeof performance !== "undefined") {
      const [nav] = performance.getEntriesByType("navigation");
      console.log("🚀 Load time:", nav.loadEventEnd);
      // Optional: Send this data to analytics server
    }
  }, []);

  return null;
}
